import axios from 'axios';
import { GetAuthToken } from 'rj-server-auth-token';
import { getQueryParam, getTicket, setTicket, getAsTicket, setCookie } from '@/utils/utils';
// 合规接口（URL 含 compliance-verification 的预检 / 审查接口）整体豁免全局错误提示，错误统一由合规工具负责
const isComplianceRequest = (config) => ((config && config.url) || '').indexOf('compliance-verification') > -1;
const seriveFactory = function (opt, errCallBack) {
    if (!getTicket() && getQueryParam('union_session_ticket')) {
      setTicket('union_session_ticket', getQueryParam('union_session_ticket'));
    }
    let ticket = getTicket() ? getTicket() : '';
    if (getQueryParam('union_session_ticket') != null && ticket != getQueryParam('union_session_ticket')) {
        setTicket('union_session_ticket', getQueryParam('union_session_ticket'));
        ticket = getQueryParam('union_session_ticket');
    }
     const asTicket = getAsTicket('as_ticket') ? getAsTicket('as_ticket') : '';
     const asUnionTicket = getAsTicket('as_union_ticket') ? getAsTicket('as_ticket') : '';
     if (asTicket != '' && asUnionTicket === '') {
         setCookie('as_union_ticket', asTicket, 1);
     }
    console.log(getTicket(), 'cookies-ticket');
    let API = axios.create(opt);
    API.interceptors.request.use(
        config => {
            // config.headers['Authorization-Code'] = 'zhuwenlong';
            config.headers['web-sign-server-auth'] = GetAuthToken({
                sysId: window._env_.VUE_APP_SYSID,
                accessKeySecret: 'bbeec637-7b95-4ef5-9878-62e2e4eb4ac8'
            });
            config.headers['lang'] = localStorage.getItem('lang');
            if (ticket != '' && ticket !== null) {
                config.headers['union_session_ticket'] = ticket;
            } else {
                delete config.headers['union_session_ticket'];
            }
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );
    // http响应拦截器
    API.interceptors.response.use(
        res => {
            let json = res.data;
            // 11000 为出口合规命中码，属业务决策而非错误，由业务层自行弹窗，不走全局错误提示；
            // 合规接口（compliance-verification）的其他错误码同样豁免，避免「全局 toast + 合规弹窗」双重提示
            if (json && json.status !== '200' && json.status !== '11000'
                && !isComplianceRequest(res.config) && !res.config.headers.download) {
                errCallBack(json);
            }
            // 如果是下载请求（通过 headers.download 标记），返回完整响应以便获取 headers
            if (res.config && res.config.headers && res.config.headers.download) {
                return res;
            }
            return res.data;
        },
        error => {
            const { response } = error;
            if (response) {
              switch (response.status) {
                case 428:
                    let reurl = window.location.href;
                    let asServiceBaseUrl;
                    if (reurl.indexOf('rjmms') > 0 || reurl.indexOf('mobiledev') > 0) {
                        asServiceBaseUrl = 'https://web-e-gw.ruijie.com.cn/api/union-session/login/' + window._env_.VUE_APP_SYSID + '?type=sid&reurl=' + reurl;
                    } else {
                         let isIE = !!window.ActiveXObject || 'ActiveXObject' in window;
                          asServiceBaseUrl = 'https://was.ruijie.com.cn/as-service/auth/';
                         if (isIE) {
                             asServiceBaseUrl += 'authorize';
                         } else {
                             asServiceBaseUrl += 'login';
                         }
                         asServiceBaseUrl = asServiceBaseUrl + '?type=qdlogin&reurl=' + reurl;
                    }
                    window.location.href = asServiceBaseUrl;
                  break;
                // 其他状态码处理...
              }
            }
            // 合规接口的网络 / HTTP 异常同样不走全局提示，统一由合规工具负责
            if (!isComplianceRequest(error.config)) {
                errCallBack({}, error);
            }
            return Promise.reject(error);
        }
    );
    return API;
};
export default seriveFactory;
